import { useTranslation } from 'react-i18next';
import PaginaTexto from '../Compartido/PaginaTexto.jsx';

const TextosServicios = ({ servicios, ruta }) => {

    const { t } = useTranslation();

    return (
        <PaginaTexto
            titulo={t("Servicios")}
            eyebrow={t("Empresa")}
            imagen={servicios.imagen_cabecera ? ruta + "/" + servicios.imagen_cabecera : null}
            html={servicios.ladesc}
        />
    );
}

export default TextosServicios;
